import { useTranslation } from 'react-i18next';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import type { AnnouncementsTableProps } from './AnnouncementsTable';
import { AnnouncementOpenButton } from './AnnouncementOpenButton';
import { DeleteAnnouncementDialog } from './DeleteAnnouncementDialog';
import {
  AnnouncementStatusBadge,
  formatActivePeriod,
} from './announcementDisplay';

export const AnnouncementsTableDesktop = ({
  announcements,
  onOpen,
  onDelete,
}: AnnouncementsTableProps) => {
  const { t } = useTranslation();

  return (
    <Table
      sx={{ minWidth: 650 }}
      aria-label={t('announcements.tableLabel') as string}
    >
      <TableHead>
        <TableRow>
          <TableCell>{t('announcements.columnTitle')}</TableCell>
          <TableCell>{t('announcements.columnStatus')}</TableCell>
          <TableCell>{t('announcements.columnActivePeriod')}</TableCell>
          <TableCell>
            <span className="sr-only">{t('announcements.columnActions')}</span>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {announcements.map((announcement) => (
          <TableRow key={announcement.id}>
            <TableCell lang="en">{announcement.title}</TableCell>
            <TableCell>
              <AnnouncementStatusBadge status={announcement.status} />
            </TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>
              {formatActivePeriod(t, announcement)}
            </TableCell>
            <TableCell>
              <Box sx={{ display: 'flex', gap: 4, justifyContent: 'flex-end' }}>
                <AnnouncementOpenButton
                  announcement={announcement}
                  onOpen={onOpen}
                />
                <DeleteAnnouncementDialog
                  title={announcement.title}
                  onConfirm={() => onDelete(announcement)}
                />
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
